import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog, RoutalLoader, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';
import AlertIcon from '../../../../../assets/svg/AlertIcon';
import { ApiKey } from '../../../../../domain/apiKey/ApiKey';
import { useUpdateApiKey } from '../../../../../hooks/apiKey/useUpdateApiKey';
import Button from '../../../../../react-components/Button';
import Text from '../../../../../react-components/Text';

interface EnableApiKeyDialogProps {
  apiKey: ApiKey;
  onClose: () => void;
}

export const EnableApiKeyDialog = ({ apiKey, onClose }: EnableApiKeyDialogProps) => {
  const { run: updateApiKey, isLoading, success, error } = useUpdateApiKey();

  useEffect(() => {
    if (success || error) {
      onClose();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error]);

  return (
    <RoutalDialog
      open
      dialogProps={{
        maxWidth: `sm`,
      }}
      onCloseDialog={onClose}
      titleContent={<Text variant="h6" intlId="settings.developers.api_keys.activate.title" />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button variant="flat" intlId="cancel" onClick={onClose} />
          <HSpacer small />
          <Button
            onClick={() => {
              apiKey.active = !apiKey.active;
              updateApiKey({ apiKey });
            }}
            disabled={isLoading}
            style={{ maxHeight: `1.2rem` }}
          >
            {isLoading ? (
              <RoutalLoader width={12} color={RoutalPalette.neutral00} />
            ) : (
              <Text intlId="settings.developers.api_keys.activate.button" style={{ color: RoutalPalette.neutral00 }} />
            )}
          </Button>
        </Grid>
      }
    >
      <Grid container direction="column" alignItems="center">
        <AlertIcon mainColor={RoutalPalette.error.medium} height="24px" width="24px" />
        <VSpacer medium />
        <Text
          style={{ fontWeight: `bold`, textAlign: `center` }}
          intlId="settings.developers.api_keys.activate.label"
        />
      </Grid>
    </RoutalDialog>
  );
};
